import React from 'react';
import { BetStGeorgeMainLogoWrapper, BetStGeorgeMainLogo } from './betstgeorge.style';

export const BetStGeorgeLogotype = (): JSX.Element => (
    <BetStGeorgeMainLogoWrapper>
        <BetStGeorgeMainLogo />
    </BetStGeorgeMainLogoWrapper>
);
